import { pdf } from '@react-pdf/renderer';

import FileSaver from 'file-saver';

import { ExportQAResults } from './ExportQAResults.tsx';

export const exportQAResultsPdf = async (
  address: { street: string; full: string },
  qaResults: string[],
) => {
  const blob = await pdf(<ExportQAResults address={address.full} qaResults={qaResults} />).toBlob();

  const fileName = `${address.street} - QC Results`;

  FileSaver.saveAs(blob, `${fileName}.pdf`);
};
